import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Slide from '@material-ui/core/Slide'
import PaymentTariffsTable from './PaymentTariffsTable'

const styles = {
  flex: {
    flex: 1,
  },
  paymentDialog: {
    maxWidth: 600,
  },
  paperFullScreen: {
    backgroundColor: '#8866ff',
  },
  paymentDialogHeader: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  paymentDialogTitle: {
    padding: '0 16px',
    color: '#fff',
    fontSize: '1.5em',
    marginBlockStart: '0.83em',
    marginBlockEnd: '0.83em',
    marginInlineStart: 0,
    marginInlineEnd: 0,
    fontFamily: 'Exo 2',
    textAlign: 'left',
    '& p': {
      margin: '10px 0',
      fontSize: 14,
    },
  },
  btnLInk: {
    fontSize: 12,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'right',
    color: 'rgb(0, 111, 255)',
    cursor: 'pointer',
    textDecoration: 'underline',
    border: 0,
    boxShadow: 'none',
    padding: 0,
    background: 'transparent',
    outline: 'none',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  tableWraper: {
    padding: 16,
  },
}

function Transition(props) {
  return (
    <Slide direction="right" {...props} timeout={{ enter: 200, exit: 300 }} />
  )
}

class PaymentTariffs extends Component {
  state = {
    open: false,
  }

  handleClickOpen = () => {
    this.setState({ open: true })
  }

  handleClose = () => {
    this.setState({ open: false })
  }

  render() {
    const { classes } = this.props

    return (
      <Fragment>
        <button className={classes.btnLInk} onClick={this.handleClickOpen}>
          Тарифы
        </button>
        <Dialog
          fullScreen
          open={this.state.open}
          onClose={this.handleClose}
          TransitionComponent={Transition}
          classes={{
            root: classes.paymentDialog,
            paperFullScreen: classes.paperFullScreen,
          }}
        >
          <header className={classes.paymentDialogHeader}>
            <IconButton
              color="inherit"
              onClick={this.handleClose}
              aria-label="Close"
            >
              <CloseIcon style={{ fill: '#fff' }} />
            </IconButton>
          </header>
          <article className={classes.paymentDialogWraper}>
            <header className={classes.paymentDialogTitle}>
              Тарифы
              <p>
                Расчет тарифа строится на основании статистики Google Analytics
                за 30 дней, предшествующих дате расчета.
              </p>
            </header>
            <section className={classes.tableWraper}>
              <PaymentTariffsTable />
            </section>
          </article>
        </Dialog>
      </Fragment>
    )
  }
}

export default withStyles(styles)(PaymentTariffs)
